import React from 'react';
import './ndoeUi.css';

/**
 * Mapping des statuts de livraison (modèle hub livreur) → ton visuel + libellé FR.
 * ⚠️ Ne PAS modifier les clés : elles doivent rester alignées sur le hub livreur
 * (src/pages/pageLivreur/) et le backend. Ajouter, ne pas renommer.
 */
export const LIVRAISON_STATUS = {
  AFFECTEE:            { tone: 'info',    label: 'Affectée' },
  PRISE_EN_CHARGE:     { tone: 'info',    label: 'Prise en charge' },
  NON_PRISE_EN_CHARGE: { tone: 'warn',    label: 'Non prise en charge' },
  EN_COURS:            { tone: 'gold',    label: 'En circulation' },
  REPORTEE:            { tone: 'warn',    label: 'Reportée' },
  LIVREE:              { tone: 'ok',      label: 'Livrée' },
  RETOUR_LIVRAISON:    { tone: 'danger',  label: 'Retour livraison' },
  RETOUR_CLIENT:       { tone: 'danger',  label: 'Retour client' },
  RETOUR_POUR_ECHANGE: { tone: 'warn',    label: 'Retour pour échange' },
  ECHANGE_A_LIVRER:    { tone: 'warn',    label: 'Échange à livrer' },
  ECHANGE_TERMINE:     { tone: 'ok',      label: 'Échange terminé' },
  // Complété le 18/07 : ces 6 statuts sont émis par le backend
  // (deliveryStatusRules.js) mais manquaient ici → ils s'affichaient en gris
  // avec leur code technique. Ajout SANS renommer les clés existantes.
  EN_ESSAI:            { tone: 'gold',    label: 'Déposée à l’essai' },
  ECHANGE_EN_COURS:    { tone: 'warn',    label: 'Échange en cours' },
  ECHANGE_ANNULE:      { tone: 'neutral', label: 'Échange annulé' },
  ECHANGE_RETOURNE:    { tone: 'danger',  label: 'Échange retourné' },
  AFFECTATION_LIBEREE: { tone: 'neutral', label: 'Affectation libérée' },
  AFFECTATION_EXPIREE: { tone: 'neutral', label: 'Affectation expirée' },
};

/**
 * Mapping des statuts de commande → ton + libellé.
 */
export const COMMANDE_STATUS = {
  CREEE:            { tone: 'neutral', label: 'Créée' },
  AFFECTEE:         { tone: 'info',    label: 'Affectée' },
  EN_CIRCULATION:   { tone: 'gold',    label: 'En circulation' },
  LIVREE:           { tone: 'ok',      label: 'Livrée' },
  REPORTEE:         { tone: 'warn',    label: 'Reportée' },
  RETOUR_LIVRAISON: { tone: 'danger',  label: 'Retour' },
};

/**
 * NdoeStatusBadge — pilule d'état sobre.
 *
 * Props :
 *  - status : clé de statut (ex. 'LIVREE') OU libellé libre
 *  - kind   : 'livraison' | 'commande' | 'custom' (défaut 'livraison')
 *  - tone   : forcer le ton si kind='custom' ('ok'|'warn'|'danger'|'info'|'gold'|'neutral')
 *  - label  : forcer le libellé
 *  - dot    : afficher une pastille de couleur
 */
export default function NdoeStatusBadge({ status, kind = 'livraison', tone, label, dot = false, className = '' }) {
  let resolvedTone = tone || 'neutral';
  let resolvedLabel = label || status || '';

  if (kind === 'livraison' && status && LIVRAISON_STATUS[status]) {
    resolvedTone = tone || LIVRAISON_STATUS[status].tone;
    resolvedLabel = label || LIVRAISON_STATUS[status].label;
  } else if (kind === 'commande' && status && COMMANDE_STATUS[status]) {
    resolvedTone = tone || COMMANDE_STATUS[status].tone;
    resolvedLabel = label || COMMANDE_STATUS[status].label;
  }

  return (
    <span className={`ndoe-badge ndoe-badge--${resolvedTone} ${className}`}>
      {dot ? <span className="ndoe-badge__dot" /> : null}
      {resolvedLabel}
    </span>
  );
}
